import { JsonObject, JsonProperty } from 'ta-json';
import { Id } from '@ess/jg-rule-executor';
import { Retailer } from '@src/app/model/retailer';
import { GetAllPublicRetailers_allPublicRetailers_edges_node } from '@src/app/generated/GetAllPublicRetailers';

@JsonObject()
export class PublicRetailer {
  @JsonProperty() id: Id<Retailer>;
  @JsonProperty() name: string;

  constructor(
    id?: Id<Retailer>,
    name?: string,
  ) {
    this.id = id;
    this.name = name;
  }

  static fromGql(gql: GetAllPublicRetailers_allPublicRetailers_edges_node): PublicRetailer {
    return new PublicRetailer(
      gql.id,
      gql.name
    );
  }
}
